<template>
  <div class="service-detail">
    <nav-bar/>
    <search-bar/>
    <div class="main" v-if="loading">
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/me/myservice' }">服务订单</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-card v-if="service_detail.platform_sale_check_state === '0'" shadow="hover" class="mb20">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">服务信息</span>
        </div>
        <el-form style="width: 500px;" label-width="100px">
          <el-form-item label="服务类型">
            <el-select v-model="form_data.type_id" placeholder="请选择" size="small">
              <el-option
                  v-for="item in types"
                  :key="item.type_id"
                  :label="item.type_name"
                  :value="item.type_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务工程师">
            <el-select v-model="form_data.level_id" placeholder="请选择" size="small">
              <el-option
                  v-for="item in levels"
                  :key="item.level_id"
                  :label="item.level_name"
                  :value="item.level_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务时间">
            <el-date-picker
                size="small"
                v-model="form_data.service_time"
                type="daterange"
                value-format="yyyy-MM-dd hh:mm:ss"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="服务地址">
            <el-select v-model="form_data.address_id"
                       :placeholder="is_Empty(form_data.address_id)?address_content:'请选择'" size="small">
              <el-option
                  v-for="item in company_address_list"
                  :key="item.address_id"
                  :label="item.address_content"
                  :value="item.address_id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发票信息">
            <el-select v-model="form_data.invoice_id" placeholder="请选择" size="small">
              <el-option
                  v-for="item in company_invoice_list"
                  :key="item.invoice_id"
                  :label="item.invoice_content"
                  :value="item.invoice_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input v-model="form_data.order_remark" disabled type="textarea" :rows="5" resize="none"/>
          </el-form-item>
          <el-form-item label="备注图片">
            <img-upload
                :file_list.sync="service_detail.order_imgs"
                :disabled="true"
            />
          </el-form-item>

          <el-form-item label="服务内容">
            <el-input v-model="service_detail.service_content" placeholder="请输入服务内容" type="textarea" :rows="5"
                      resize="none"/>
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 服务信息 审核通过后显示 -->
      <el-card shadow="hover" class="mb20">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">服务信息</span>
        </div>
        <el-table :data="[service_detail]" style="width: 100%" border>
          <el-table-column prop="order_no" label="订单编号" align="center"></el-table-column>
          <el-table-column prop="type_name" label="服务类型" align="center"></el-table-column>
          <el-table-column prop="level_name" label="服务人员" align="center"></el-table-column>
          <el-table-column label="服务时间" align="center">
            <template slot-scope="scope">
            <span>{{
                formatDate(scope.row.service_start_time, 'yyyy-MM-dd')
              }}~{{ formatDate(scope.row.service_end_time, 'yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_distance" label="距离（km）" align="center"></el-table-column>
          <el-table-column
              prop="order_actual_price"
              label="价格"
              align="center"
              v-if="service_detail.platform_sale_check_state == '1'"
          ></el-table-column>
        </el-table>
      </el-card>
      <!-- 合同信息 审核通过后显示-->
      <el-card shadow="hover" class="mb20" v-if="!is_Empty(service_detail.company_contract)">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">合同信息</span>
        </div>
        <img-upload
            :file_list.sync="service_detail.company_contract"
            :disabled="true"
        />
      </el-card>
      <!-- 服务描述 审核通过后显示-->
      <el-card shadow="hover" class="mb20">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">问题描述</span>
        </div>
        <el-input
            type="textarea"
            class="mb20"
            :rows="10"
            :value="service_detail.order_remark"
            resize="none"
            :disabled="true"
        ></el-input>
        <div>

          <img-upload
              :file_list.sync="service_detail.order_imgs"
              :disabled="true"
          />
        </div>
        <div v-if="!is_Empty(service_detail.company_contract)">
          <div class="before-title black mb20 mt20">服务内容</div>
          <el-input
              type="textarea"
              class="mb20"
              :rows="10"
              :value="service_detail.service_content"
              resize="none"
              :disabled="true"
          ></el-input>
        </div>
        <div class="mt20 fr ac jc">
          <!-- 待审核订单 -->
          <template
              v-if="service_detail.platform_sale_check_state !== '1' || service_detail.contract_check_state !== '1'">
            <el-button size="medium" v-if="hasPermission(897)" @click="cancelOrder">取消订单</el-button>
          </template>
          <!--          <template v-if="service_detail.order_state == '2'">-->
          <!--            <el-button size="medium" type="primary" @click="memberConfirmOrder">确认订单</el-button>-->
          <!--            <el-button size="medium" @click="cancelOrder">取消订单</el-button>-->
          <!--          </template>-->
          <!-- 待评价订单 -->
          <template v-if="service_detail.technician_assign_state === '1' && service_detail.assessment_state === '0'">
            <el-button
                size="medium"
                type="primary" v-if="hasPermission(898)"
                @click="go(`/serviceassents?id=${service_detail.order_id}`)"
            >立即评价
            </el-button>
          </template>
        </div>
      </el-card>

    </div>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  props: {},
  data() {
    return {
      service_detail: {},
      loading: false
    };
  },
  computed: {},
  created() {
    this.getServiceOrderDetail();
  },
  mounted() {
  },
  watch: {},
  methods: {
    // 取消订单
    cancelOrder(id) {
      this.$confirm("是否取消该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("serviceInterfaces/v1.0/cancelOrder", {
              order_id: this.$route.query.id
            }).then(res => {
              this.$message({
                type: "success",
                message: "已取消!"
              });
              this.getServiceOrderDetail();
            });
          })
          .catch(() => {
          });
    },
    // 确认订单
    memberConfirmOrder() {
      this.post("serviceInterfaces/v1.0/memberConfirmOrder", {
        order_id: this.$route.query.id
      }).then(res => {
        this.$message({
          message: res.data,
          type: "success"
        });
        this.getServiceOrderDetail();
      });
    },
    // 订单详情
    getServiceOrderDetail() {
      this.post("serviceInterfaces/v1.0/getServiceOrderDetail", {
        order_id: this.$route.query.id
      }).then(res => {
        let obj = res.data;
        obj.company_contract = this.strToArr(obj.company_contract);
        obj.order_imgs = this.strToArr(obj.order_imgs);
        this.service_detail = obj
        this.loading = true;
      });
    }
  },
  components: {NavBar, SearchBar, FooterBar}
};
</script>

<style scoped lang="scss">
.service-detail {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .info_box {
      background-color: #fff;
      padding: 20px;
      font-size: 14px;

      .order_cell {
        .order_cell_title {
          width: 130px;
          text-align: right;
        }

        .pay_table {
          width: calc(100% - 170px);
          margin-left: 20px;
          border: 1px solid #e5e5e5;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            &:nth-of-type(2) {
              border-bottom: none;
            }

            .th {
              height: 50px;
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              width: 25%;
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;
              // border-bottom: 1px solid #e5e5e5;
              &:last-child {
                border-right: none;
              }
            }
          }
        }

        .img {
          width: 100px;
          height: 100px;
          margin-right: 20px;
        }
      }

      .receipt {
        width: 40%;
        border: 1px solid #e5e5e5;

        .top {
          padding: 20px;
          border-bottom: 1px solid #e5e5e5;
        }

        .bottom {
          padding: 30px 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/serviceOrder/servicedetail.vue